import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeIndex:'1'
  },
  getters: {
  },
  mutations: {
    changeactiveIndex (state,val) { 
      // 变更状态
      state.activeIndex = val
    }
  },
  actions: {
  },
  modules: {
  }
})
